export const getDownloadUrl = (
  path: string | undefined | null,
  token: string | undefined | null,
): string | undefined => {
  if (!path || !token) {
    return undefined;
  }
  return `${path}?${token}`;
};
